import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EnvironmentService } from './environment.service';

export const lowerEnvironmentOnly: CanActivateFn = () => {
  const environmentService = inject(EnvironmentService);
  const router = inject(Router);

  return environmentService.isPermissionOverrideEnvironment || router.parseUrl('/access-restricted');
};
